import { BaseService } from './../base'

export class DistributionService extends BaseService {
  static get entity () {
    return 'distribution'
  }
  static get name () {
    return 'distribution'
  }
}